import React from "react";

const PolicyHeader: React.FC = () => {
  return null;
};

export default PolicyHeader;
